import React from 'react';
import { Modal, Spinner } from "player-components";
import { useEffect } from "react";
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate, useLocation } from "react-router-dom";
import { fetchLibrarySongsAsync, selectLibrarySongs} from '../../features/library/librarySlice';
import {createSetlistFromData, selectSetlistsSetlists} from '../../features/setlists/setlistsSlice';
import { selectUser } from '../../features/auth/authSlice';
import { useCallback } from 'react';

import { createSetlistFromQuery } from "./createSetlistFromQuery";

// pgw 07-feb-2026
let doprint = false;
// let doprint = true;



function useQuery() {
    const { search } = useLocation();
    return React.useMemo(() => new URLSearchParams(search), [search]);
}

export const setlistTitleExists = (title, existingSetlists) => {
  if (!title || !existingSetlists) return false;

  const normalisedTitle = title.trim().toLowerCase();

  // existingSetlists can be an array OR an object map
  const list = Array.isArray(existingSetlists)
    ? existingSetlists
    : Object.values(existingSetlists);

  return list.some(
    setlist =>
      typeof setlist?.title === "string" &&
      setlist.title.trim().toLowerCase() === normalisedTitle
  );
};

const doesSetlistAlreadyExist = (incomingSetlist, existingSetlists) => {
  // 1️⃣ ID match (strong)
  if (existingSetlists.byId?.[incomingSetlist.id]) {
    return { type: "id", existing: existingSetlists.byId[incomingSetlist.id] };
  }

  // 2️⃣ Content match (title + songs)
  const incomingSongIds =
    incomingSetlist.items?.map(i => i.songId).sort().join("|");

  const match = Object.values(existingSetlists.byId || {}).find(s => {
    const existingSongIds =
      s.items?.map(i => i.songId).sort().join("|");
    return (
      s.title === incomingSetlist.title &&
      existingSongIds === incomingSongIds
    );
  });

  if (match) {
    return { type: "content", existing: match };
  }

  return null;
};

const CreateSetlistContainer = () => {
    const setlists = useSelector(selectSetlistsSetlists);
    const librarySongs = useSelector(selectLibrarySongs);
    const query = useQuery();
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const currentUser = useSelector(selectUser);

	useEffect(() => {
	  (async () => {
		if (doprint) console.log("[CreateSetlistContainer] mounted p1");


		if (doprint) console.log("[CreateSetlistContainer] mounted p1 dispatch = ", dispatch);
		if (doprint) console.log("[CreateSetlistContainer] mounted p1 currentUser = ", currentUser);
		if (doprint) console.log("[CreateSetlistContainer] mounted p1 setlists = ", setlists);
		if (doprint) console.log("[CreateSetlistContainer] mounted p1 query = ", query);


		await createSetlistFromQuery({
		  dispatch,
		  currentUser,
		  setlists,
		  query,
		});

		navigate(`/setlist/${query.get("setlistId")}`, { replace: true });
	  })();
	}, []);



    return <div className="flex justify-center mt-4 mb-4">
        <Spinner />
        
    </div>
}

export default CreateSetlistContainer;